import { FileText, FileImage, FileArchive, FileSpreadsheet } from 'lucide-vue-next'

// Ícone e rótulo do formato por extensão — fonte única para as telas
// que listam arquivos (Documentos, Pagamentos, Manutenção).
const KINDS = {
  pdf: { icon: FileText, label: 'PDF' },
  zip: { icon: FileArchive, label: 'ZIP' },
  jpg: { icon: FileImage, label: 'JPG' },
  png: { icon: FileImage, label: 'PNG' },
  csv: { icon: FileSpreadsheet, label: 'CSV' },
}

export const documentKind = (kind) => KINDS[kind] ?? KINDS.pdf
